// Class
import { CartItem } from "../classes/CartItem"
import { CartTrackingData } from "../classes/CartTrackingData"
import buildPageCategoriesArr from "./buildPageCategories"

function buildCartTrackingData(
	quantity: number,
	prestIds: string[],
	prestNames: string[],
	itemPriceAti: number,
	beginDate: string,
	endDate: string,
	duration: number,
	liheId: string,
	liheName: string,
	region: string,
	station: string
): CartTrackingData {
	const cartTrackingItem = new CartItem()
	const categoriesArr: string[] = buildPageCategoriesArr()

	cartTrackingItem.item_quantity = quantity || 0
	cartTrackingItem.item_PrestIds = prestIds || []
	cartTrackingItem.item_PrestNames = prestNames || []
	cartTrackingItem.item_price_ati = itemPriceAti || 0
	cartTrackingItem.item_begin_date = beginDate || ""
	cartTrackingItem.item_end_date = endDate || ""
	cartTrackingItem.item_duration = duration ? `${duration} days` : ""
	cartTrackingItem.item_LiheId = liheId || ""
	cartTrackingItem.item_LiheName = liheName || ""
	cartTrackingItem.page_category1 = categoriesArr[0] || region || ""
	cartTrackingItem.page_category2 = categoriesArr[1] || station || ""
	cartTrackingItem.page_category3 = categoriesArr[2] || "" // Empty string for page_category3
	cartTrackingItem.page_category4 = categoriesArr[3] || "" // Empty string for page_category4
	cartTrackingItem.pageName = window.lihe.name || ""

	cartTrackingItem.checkIsValid()

	const ecommerce = {
		items: [cartTrackingItem],
	}

	const cartTrackingData = new CartTrackingData(ecommerce)
	return cartTrackingData
}

export default buildCartTrackingData
